import { render, staticRenderFns } from "./LfHonorStyleTow.vue?vue&type=template&id=6d79ab0a&"
import script from "./LfHonorStyleTow.vue?vue&type=script&lang=js&"
export * from "./LfHonorStyleTow.vue?vue&type=script&lang=js&"
import style0 from "./LfHonorStyleTow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports